import React from 'react';
import SideContainerComponent from '../SideContainer.component';
import { MainContentContainer, MainSection } from '../OtherPages.styles';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import PageHeader from '../../Components/PageHeader/PageHeader.component';
import Breadcrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import Overview from './Overview/Overview.component';
import Features from './Features/Features.component';
import Development from './Development/Development.component';
import Process from './Process/Process.page';
import Access from './Access/Access.component';
import Connected from './Connected/Connected.component';
import CTA from './CTA/CTA.component';
import { SafetyManualsContent } from './Manuals.styles';

const Manuals = () => {
  return (
    <MainContentContainer>
      <HelmetHelper
        title="Workplace Safety Manuals & Online Access"
        description="Yoda Safety Services can develop workplace safety manuals for your business and make them available online through your company account for easier employee access."
      />

      <SideContainerComponent />

      <MainSection>
        <Breadcrumbs one="Home" oneLink="/" two="Safety Manuals" />

        <PageHeader
          eyebrow="Safety Manuals"
          title="Workplace Safety Manuals Built for Your Business"
          desc="We can develop workplace safety manuals for your organization and make them available online through your company account so important safety information is easier for your team to access."
        />
        <SafetyManualsContent>
          {/* ----------------------------------
      Intro
  ----------------------------------- */}

          <Overview />

          {/* ----------------------------------
      Feature Strip
  ----------------------------------- */}

          <Features />

          {/* ----------------------------------
      Manual Development
  ----------------------------------- */}
          <Development />
          {/* ----------------------------------
      Process
  ----------------------------------- */}

          <Process />

          {/* ----------------------------------
      Online Access
  ----------------------------------- */}

          <Access />

          {/* ----------------------------------
      Connected Tools
  ----------------------------------- */}
          <Connected />

          {/* ----------------------------------
      Final CTA
  ----------------------------------- */}
          <CTA />
        </SafetyManualsContent>
      </MainSection>
    </MainContentContainer>
  );
};

export default Manuals;
